/**
 * Where a page's content sits when it is shorter than the screen.
 * `page.contentAlign` is 'top' or 'center'; unset keeps each layout's own default:
 * text-only pages start at the top, the others are centred.
 */

export const CONTENT_ALIGNS = ['top', 'center'];

export function pageContentCentered(page, isHtmlOnly) {
    if (page?.contentAlign === 'center') return true;
    if (page?.contentAlign === 'top') return false;
    return !isHtmlOnly;
}

/** The same choice from a stored page, using the public route's layout rules. */
export function draftContentCentered(page, { home = false } = {}) {
    const type = page?.gallery?.type || (home ? 'masonry' : 'none');
    const isHtmlOnly = home ? type === 'none' : type !== 'masonry' && type !== 'slideshow';
    return pageContentCentered(page, isHtmlOnly);
}
